import Icon from '../components/Icon.vue'

Icon.register({"stack-exchange":{"width":1280,"height":1792,"paths":[{"d":"M1259 1253v66q0 85-57.5 144.5t-138.5 59.5h-57l-260 269v-269h-529q-81 0-138.5-59.5t-57.5-144.5v-66h1238zM1259 927v255h-1238v-255h1238zM1259 599v255h-1238v-255h1238zM1259 459v67h-1238v-67q0-84 57.5-143.5t138.5-59.5h846q81 0 138.5 59.5t57.5 143.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stack-exchange.js
// module id = 911
// module chunks = 0